var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BuyerCampaignsList',{attrs:{"buyer-campaigns":_vm.buyerCampaigns,"campaign-spend-data":_vm.campaignSpend,"is-loading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }